export enum Region {
  NA = "NA",
  EMEA = "EMEA",
  DEV = "DEV", // These values should not be renamed, since they are being stored.
}
export const getCurrentRegion = (): Region => {
  // Prefer build-time environment (deployment-controlled)
  const envRegion = (import.meta.env.VITE_REGION as string | undefined)?.trim()?.toUpperCase();
  if (envRegion) {
    switch (envRegion) {
      case "NA":
        return Region.NA;
      case "EMEA":
        return Region.EMEA;
      case "DEV":
        return Region.DEV;
      default:
        return Region.NA;
    }
  }

  // Fallback to legacy localStorage selection (for backward compatibility)
  const regionString: string | null = localStorage.getItem("SELECTED_REGION");
  switch (regionString) {
    case "NA":
      return Region.NA;
    case "EMEA":
      return Region.EMEA;
    case "DEV":
      return Region.DEV;
    default:
      return Region.NA;
  }
};
